import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import ProductCard from "./ProductCard";
import "../css/products.css";

function TrendingProducts() {

    const [products, setProducts] = useState([]);

    useEffect(() => {

        axios
            .get(`${API_URL}/trending-products`)
            .then((res) => {

                console.log("Trending Products API:", res.data);

                // Make sure API response is an array
                if (Array.isArray(res.data)) {
                    setProducts(res.data);
                } else if (Array.isArray(res.data.products)) {
                    setProducts(res.data.products);
                } else {
                    console.error(
                        "Trending Products API did not return an array:",
                        res.data
                    );

                    setProducts([]);
                }

            })
            .catch((err) => {

                console.error(
                    "Trending Products Error:",
                    err.response?.data || err.message
                );

                setProducts([]);

            });

    }, []);

    return (

        <section className="products-section">

            <h2 className="section-title">
                🔥 Trending Products
            </h2>

            <div className="products-grid">

                {products.length > 0 ? (

                    products.map((product) => (

                        <ProductCard
                            key={product.id}
                            product={product}
                        />

                    ))

                ) : (

                    <p>No trending products available.</p>

                )}

            </div>

        </section>

    );
}

export default TrendingProducts;